import {useEffect, useState} from "react";


const useSystemDarkMode = () => {
    const getSystemDarkMode = () =>
        window.matchMedia("(prefers-color-scheme: dark)").matches;

    const [darkMode, setDarkMode] = useState(getSystemDarkMode);

    useEffect(() => {
        const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");

        const handleChange = (event) => {
            setDarkMode(event.matches);
        };

        mediaQuery.addEventListener("change", handleChange);

        // Initial class setting
        document.body.classList.add("parent-portal");

        return () => {
            mediaQuery.removeEventListener("change", handleChange);
            document.body.classList.remove("parent-portal");
        };
    }, []);

    return { darkMode, setDarkMode };
};


export default useSystemDarkMode